<template>
    <app-layout title="Te rapporteren">
        <template #header>
            <page-title title="Te rapporteren" />
        </template>

        <template #pageContent>
            <Form @submitted="postForm" layout="horizontal" class="w-full">
                <Input
                    label="Duedate van"
                    name="duedate_from"
                    type="date"
                    placeholder="dd-mm-jjjj"
                    v-model="form.duedate_from"
                    :error="form.errors.duedate_from"
                    layout="vertical"
                />
                <Input
                    label="Duedate tot en met"
                    name="duedate_until"
                    type="date"
                    placeholder="dd-mm-jjjj"
                    v-model="form.duedate_until"
                    :error="form.errors.duedate_until"
                    layout="vertical"
                />
                <Select
                    label="ADI"
                    name="executor"
                    :emptyOption="true"
                    :options="allExecutors"
                    v-model="form.executor"
                    :error="form.errors.executor"
                    layout="vertical"
                    v-if="this.$page.props.user.permissions.includes('requests.view.all')"
                />

                <Button text="Zoeken" buttonType="submit" buttonClass="filter" :loading="form.processing" />
                <Button text="Exporteren" buttonClass="download" @click="exportToReportSearch" />
            </Form>

            <Table :id="'overview-requests-visits'" :values="requests" class="mt-4">
                <thead>
                <tr>
                    <Th id="duedate">Duedate</Th>
                    <Th id="executor">ADI</Th>
                    <Th id="planned_at">Gepland op</Th>
                    <Th id="reference">Referentie</Th>
                    <Th id="address">Inspectie adres</Th>
                    <Th id="postal_code">Postcode</Th>
                    <Th id="place">Gemeente</Th>
                    <Th id="overdue_info">Overdue info</Th>
                    <Th id="new_duedate">Nieuwe duedate</Th>
                    <Th :sort="false" class="w-[75px]"></Th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(request, key) in state.sortedValues['overview-requests-visits']"
                    :key="key"
                    :class="{ 'bg-orange-200': request.duedate && moment(request.duedate) < moment().add(-1, 'days') && request.overdue_info,
                        'bg-red-200': request.duedate && moment(request.duedate) < moment().add(-1, 'days') && request.overdue_info === null,
                        'bg-purple-200': request.duedate && moment(request.duedate).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD'),
                    }"
                >
                    <Td>
                        {{ (request.duedate) ? moment(request.duedate).format('DD-MM-YYYY') : '' }}
                    </Td>
                    <Td>
                        {{ request.name }}
                    </Td>
                    <Td>
                        {{ (request.planned_at) ? moment(request.planned_at).format('DD-MM-YYYY') : '' }}
                    </Td>
                    <Td>
                        <Link :href="route('requests.detail',  {'id': request.id})">
                            {{ request.reference }}
                        </Link>
                    </Td>
                    <Td>{{ request.address }}</Td>
                    <Td>{{ request.postal_code }}</Td>
                    <Td>{{ request.place }}</Td>
                    <Td>{{ request.overdue_info }}</Td>
                    <Td>
                        <template v-if="request.new_duedate">
                            {{  moment(request.report.new_duedate).format('DD-MM-YYYY') }}
                        </template>
                        <template v-else-if="request.overdue_info !== null && moment().isAfter(moment(request.report.duedate))">
                            Datum onbekend
                        </template>
                    </Td>
                    <Td>
                        <Button
                            htmlType="a"
                            buttonClass="show"
                            size="small"
                            title="Details"
                            :href="route('requests.detail',  {'id': request.id})"
                        />
                        <Button
                            htmlType="a"
                            buttonClass="edit"
                            size="small"
                            title="Bewerken"
                            :href="route('requests.edit', { 'request': request.id })"
                            v-if="this.$page.props.user.permissions.includes('requests.edit')"
                        />
                    </Td>
                </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Input from '@/Components/Input.vue'
import Form from '@/Components/Form.vue'
import Select from '@/Components/Select.vue'

import store from '@/store'
import moment from "moment"
import {Link, useForm} from '@inertiajs/inertia-vue3';
import {Inertia} from "@inertiajs/inertia";

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Input,
        Form,
        Select,
        Link,
    },
    props: [
        'requests',
        'requestTypes',
        'executors',
    ],
    setup (props){
        let allExecutors = {}//All executors, also blocked ones
        const urlQueryString = window.location.search
        const urlParams = new URLSearchParams(urlQueryString);
        const now = new Date();

        props.executors.forEach(function(executor) {
            allExecutors[executor.username] = executor.name

            if (executor.status === 'pending')
            {
                allExecutors[executor.username] += ' (Nog niet in dienst)'
            }
        })

        const form = useForm({
            duedate_from: urlParams.get('duedate_from') ?? null,
            duedate_until: urlParams.get('duedate_until') ?? null,
            executor: urlParams.get('executor') ?? null,
        })

        function postForm()
        {
            Inertia.get(
                window.location.href,
                {
                    duedate_from: form.duedate_from,
                    duedate_until: form.duedate_until,
                    executor: form.executor,
                    column: store.state.currentCol[store.state.currentTableId],
                    direction: store.state.currentDir[store.state.currentTableId],
                    page: 1,
                },
                {
                    // replace: true,
                    preserveState: true,
                    'only': ['requests'],
                    onSuccess: () => {
                        store.changeAllValues({values: props.requests, id: store.state.currentTableId})
                    }
                }
            )
        }

        function exportToReportSearch()
        {
            axios.post(route('requests.to-report.export'),
            {
                    duedate_from: form.duedate_from,
                    duedate_until: form.duedate_until,
                    executor: form.executor,
                    column: store.state.currentCol[store.state.currentTableId],
                    direction: store.state.currentDir[store.state.currentTableId],
                },
                { responseType: 'blob' }
            )
                .then((response) => {

                    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    let fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Te rapporteren.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                })
                .catch(function (error) {
                    console.log(error)
                });
        }

        return {
            state: store.state,
            ...store,
            allExecutors,
            form,
            postForm,
            now,
            exportToReportSearch,
        }
    },
    created: function () {
        this.moment = moment;
    },
}

</script>
